import {getPreOrderById, isLoading} from './../../store/cut-to-size/reducers';
import {
    fetchPreOrdersCts,
    sendPreorderMessage,
    sendApprovePreorderMessage,
    cancelPreorder, reactivatePreorder, downloadPreorderFile, markMessagesAsReaded, fetchPreOrderDetails
} from './../../store/cut-to-size/actions'
import { connect } from 'react-redux'
import PreOrdersCtsDetails from './PreOrdersCtsDetails'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import {requiredAdvancePayment} from '../../store/login/reducers'

const mapStateToProps = (state, { match }) => {
    let preOrder = getPreOrderById(state,match.params.open)
    if (!preOrder) preOrder = state.cutToSize.preOrderDetail
    return {
        preOrderId: match.params.open,
        preOrder: preOrder,
        isLoading: isLoading(state),
        requiredAdvancePayment: requiredAdvancePayment(state),
        showPreOrderCommunicationAlert: state.cutToSize.showPreOrderCommunicationAlert,
        communicationError: state.cutToSize.communicationError,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPreOrdersCts: (callback) => dispatch(fetchPreOrdersCts(callback)),
        sendMessage: (formData, callback) => dispatch(sendPreorderMessage(formData, callback)),
        sendApproveMessage: (formData, callback) => dispatch(sendApprovePreorderMessage(formData, callback)),
        cancelPreorder: (preorderId) => dispatch(cancelPreorder(preorderId)),
        reactivatePreorder: (preorderId) => dispatch(reactivatePreorder(preorderId)),
        downloadFile: (file) => dispatch(downloadPreorderFile(file)),
        markMessagesAsReaded: (preorderId) => dispatch(markMessagesAsReaded(preorderId)),
        fetchPreOrderDetails: (preorderId, callback) => dispatch(fetchPreOrderDetails(preorderId, callback)),
        hideCommunicationAlert: () => dispatch({type:'HIDE_PRE_ORDER_COMMUNICATION_ALERT'})
    }
}

const PreOrdersCtsDetailsContainer = withRouter(
    injectIntl(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(PreOrdersCtsDetails)
    )
)

export default PreOrdersCtsDetailsContainer
